<template>
  <el-table-column
    prop="usability_days"
    sortable="custom"
    label="Szavatosság nap"
    show-overflow-tooltip
    min-width="180"
  >
    <template slot-scope="scope">
      {{ scope.row.usability_days || '-' }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'usability_days',
  };
</script>
